import React, { useState, useEffect } from 'react';

import { TextField } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalCompra(props) {
  const compra = props.model;
  const [dataChanging, setDataChanging] = useState({
    type: compra.type || '',
    // state: compra.state || '',
  });

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  return (
    <>
      <Modal
        title={`Nueva Cuota de compra`}
        model={ compra }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/cuota-compras'
        dataForce={{
          // state: dataChanging.state,
          type: dataChanging.type,

        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(compra.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          type="text"
          name="description"
          margin="normal"
          fullWidth
          defaultValue={!!compra ? compra.description : ''}
          // onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <TextField
          label="Cuota"
          type="number"
          name="cuota"
          margin="normal"
          fullWidth
          defaultValue={!!compra ? compra.cuota : ''}
          inputProps={{ step: "any" }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            value={dataChanging.type || compra.type || ''}
            onChange={(e) => handleChange('type', e.target.value)}
            required
            inputProps={{ name: 'type' }}
          >
            <MenuItem value="Compra">Compra</MenuItem>
            <MenuItem value="Cobertura">Cobertura</MenuItem>
          </Select>
        </FormControl>
      </Modal>
    </>
  );
}
